import SvgText from "./text";


export default SvgText;